export default __webpack_public_path__ + "static/media/partner2.10319752.png";